import React from "react";
import { Form, InputGroup } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";

import {
  Button,
  CustomInput,
  Description,
  Title,
} from "../../Components/CustomComponents";
import AccountLayout from "../../Components/Layouts/AccountLayout";
import Toast from "../../Hooks/useToast";
import { forgotPassword } from "../../redux/slices";
import { ACCOUNT_ENUM } from "./Route";

export default function ForgotPassword({ setPage, loginAs }) {
  const dispatch = useDispatch();
  const forgotPasswordLoading = useSelector(
    (state) => state.auth.forgotPasswordLoading
  );

  const { handleSubmit, control } = useForm();

  const handleBackButtonClick = () => {
    setPage(ACCOUNT_ENUM.LOGIN);
  };

  const portal = loginAs === "agent" ? "agent" : "admin";

  const handleDataSubmit = async (userData) => {
    if (!userData?.email?.trim()) {
      Toast("Please enter your email", "error");
      return;
    }

    try {
      const envelope = await dispatch(
        forgotPassword({
          email: userData.email.trim(),
          loginAs: portal,
        })
      ).unwrap();
      const msg =
        envelope?.message ||
        "If this email is registered, you will receive reset instructions.";
      Toast(msg, "success");
      setPage(ACCOUNT_ENUM.LOGIN);
    } catch (err) {
      const msg =
        err?.body?.message ??
        err?.data?.message ??
        err?.message ??
        "Could not send reset email.";
      Toast(msg, "error");
    }
  };

  return (
    <AccountLayout
      hasBackButton={true}
      handleBackButton={handleBackButtonClick}
    >
      <Title text="Forgot Password" classes="mb-2" />
      <Description
        text="Enter your registered email address to reset your password."
        classes="text-center fs-7"
      />
      <Form onSubmit={handleSubmit(handleDataSubmit)}>
        <Controller
          control={control}
          name="email"
          render={({ field: { onChange } }) => (
            <InputGroup
              className="mb-3"
              style={{
                width: "300px",
              }}
            >
              <CustomInput
                placeholder="Email"
                type="email"
                onChange={onChange}
              />
            </InputGroup>
          )}
        />
        <Button
          text={forgotPasswordLoading ? "Please wait..." : "Continue"}
          classes="mt-3 mb-2"
          disabled={forgotPasswordLoading}
          type="submit"
        />
      </Form>
    </AccountLayout>
  );
}
